import React from 'react';
import { Badge, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import versionService from '../services/versionService';

const VersionIndicator = ({
    showBuildNumber = true,
    size = 'sm',
    variant = 'secondary',
    isChecking = false,
    isOutdated = false,
    lastCheckTime = null,
    onClick = null,
    className = ''
}) => {
    const currentVersion = versionService.getCurrentVersionInfo();

    const getVariant = () => {
        if (isOutdated) return 'warning';
        return variant;
    };

    const getTooltipText = () => {
        let text = `Version: ${currentVersion.version}`;
        if (showBuildNumber) {
            text += `\nBuild: ${currentVersion.buildNumber}`;
        }

        if (lastCheckTime) {
            text += `\nLast checked: ${lastCheckTime.toLocaleString()}`;
        }

        if (isOutdated) {
            text += '\n⚠️ Update available - Click to refresh';
        } else if (isChecking) {
            text += '\n🔄 Checking for updates...';
        }

        if (onClick) {
            text += '\n(Click for more info)';
        }

        return text;
    };

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const content = (
        <Badge
            bg={getVariant()}
            text={getVariant() === 'warning' ? 'dark' : 'light'}
            className={`version-indicator ${onClick ? 'cursor-pointer' : ''} ${className}`}
            onClick={handleClick}
            style={{
                cursor: onClick ? 'pointer' : 'default',
                fontSize: size === 'sm' ? '0.7rem' : '0.8rem'
            }}
        >
            {isChecking && (
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-1"
                    style={{ width: '0.8rem', height: '0.8rem' }}
                />
            )}
            {isOutdated && <i className="bi bi-exclamation-triangle me-1"></i>}
            v{currentVersion.version}
            {showBuildNumber && (
                <>
                    <span className="mx-1">•</span>
                    #{currentVersion.buildNumber}
                </>
            )}
        </Badge>
    );

    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="version-tooltip">
                    <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
                        {getTooltipText()}
                    </div>
                </Tooltip>
            }
        >
            {content}
        </OverlayTrigger>
    );
};

export default VersionIndicator;